import { dataApiUrl as buildDataApiUrl } from '../utils/url';
import AuthAxios from '../utils/authAxios';
import { useQuery, useMutation } from 'react-query';

const dataApiUrl = buildDataApiUrl();

export const getDsps = () => AuthAxios.get(`${dataApiUrl}/dsps`);
export const patchDsp = (id, data) => AuthAxios.patch(`${dataApiUrl}/dsps/${id}`, data);

export const useGetDsps = () => useQuery(['getDsps'], getDsps, { refetchOnWindowFocus: false });
export const useSegmentedPatchDsp = (options = {}) => {
  const { onSuccess = () => {}, onError = () => {} } = options;
  return useMutation(
    async (mutationOptions = {}) => {
      //mutationConfigs is an array of id and (patch) data objects
      const { mutationConfigs } = mutationOptions;
      const failedPatches = [];

      for (let mutationConfig of mutationConfigs) {
        const { id, data } = mutationConfig;
        try {
          await patchDsp(id, data);
        } catch (error) {
          failedPatches.push(`${id} patch failed, ${error}`);
        }
      }

      if (failedPatches.length > 0) {
        throw new Error(failedPatches.join('\n'));
      }
    },
    {
      onSuccess,
      onError,
    }
  );
};
